import React from "react";
import { Box, Chip } from "@mui/material";

export interface SongCapoKeyBarProps {
  capo?: string;
  songKey?: string;
  isHebrew?: boolean;
}

export const formatCapoLabel = (val: string): string => {
  const trimmed = val.trim();
  if (/^(capo|קאפו)/i.test(trimmed)) {
    return trimmed;
  }
  return `Capo: ${trimmed}`;
};

export const formatKeyLabel = (val: string): string => {
  const trimmed = val.trim();
  if (/^key/i.test(trimmed)) {
    return trimmed;
  }
  return `Key: ${trimmed}`;
};

export const SongCapoKeyBar: React.FC<SongCapoKeyBarProps> = ({
  capo,
  songKey,
  isHebrew = false,
}) => {
  const hasCapo = Boolean(capo && capo.trim());
  const hasKey = Boolean(songKey && songKey.trim());

  if (!hasCapo && !hasKey) {
    return null;
  }

  return (
    <Box
      data-testid="song-capo-key-bar"
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0.75,
        alignItems: "center",
        mb: { xs: 1, sm: 1.25 },
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        whiteSpace: "normal",
        direction: isHebrew ? "rtl" : "ltr",
        userSelect: "none",
      }}
    >
      {hasCapo && (
        <Chip
          data-testid="song-capo-chip"
          label={formatCapoLabel(capo!)}
          variant="outlined"
          size="small"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "0.8rem", sm: "0.85rem" },
            px: 0.5,
            bgcolor: "#f8fafc",
            borderColor: "#cbd5e1",
            color: "#334155",
            direction: "ltr",
            unicodeBidi: "isolate",
          }}
        />
      )}
      {hasKey && (
        <Chip
          data-testid="song-key-chip"
          label={formatKeyLabel(songKey!)}
          variant="outlined"
          color="primary"
          size="small"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "0.8rem", sm: "0.85rem" },
            px: 0.5,
            direction: "ltr",
            unicodeBidi: "isolate",
          }}
        />
      )}
    </Box>
  );
};
